import { DeviceSearchResponse } from 'api/Responses/SearchResponses';

export type PartAction =
  | { type: 'REF'; payload: string }
  | { type: 'QTY'; payload: string }
  | { type: 'ADDITIONAL_INSPECTION' | 'JAPANESE_ADDITIONAL_INSPECTION'; payload: string }
  | { type: 'SEARCH'; payload: DeviceSearchResponse }
  | {
      type: 'DEBRIS_INSPECTION';
      payload: boolean;
    }
  | {
      type: 'FUNCTION_TEST';
      payload: boolean;
    }
  | {
      type: 'TORQUE_TEST';
      payload: boolean;
    }
  | {
      type: 'PRONE_TO_DEBRIS';
      payload: boolean;
    };
/**
 * Actions for the part reducer
 */
export const partActions = {
  // Update part reference
  ref: (ref: string): PartAction => ({ type: 'REF', payload: ref }),
  // Update part qty
  qty: (name: string): PartAction => ({ type: 'QTY', payload: name }),
  // Update part from search result
  fromSearch: (part: DeviceSearchResponse): PartAction => ({ type: 'SEARCH', payload: part }),
};
